import { jsx } from "react/jsx-runtime";
function LogoPage({
  logoSrc,
  pageWidth,
  pageHeight,
  logoWidthPx = 240,
  alt = "Logo"
}) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: "print-page",
      style: {
        position: "relative",
        overflow: "hidden",
        boxSizing: "border-box",
        width: pageWidth,
        height: pageHeight,
        background: "#ffffff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      children: /* @__PURE__ */ jsx(
        "img",
        {
          src: logoSrc,
          alt,
          style: { width: logoWidthPx, height: "auto" }
        }
      )
    }
  );
}
export {
  LogoPage
};
//# sourceMappingURL=LogoPage.js.map
